<template>
  <div class="userOptions mask">
    <el-form :model="userForm" :rules="rules" ref="optsForm" label-width="120px">
      <p v-if="!isAdd" class="title">编辑</p>
      <p v-else class="title">新增</p>
      <div class="scrollDiv">
        <el-form-item label="员工ID: " prop="employee_id" >
          <el-input placeholder="请输入员工ID" v-model="userForm.employee_id" @change="ChangeId" ></el-input>
        </el-form-item>
        <el-form-item label="姓名：" prop="username" >
          <el-input placeholder="请填写姓名" v-model="userForm.username" disabled></el-input>
        </el-form-item>
        <el-form-item label="系统："  prop="system">
          <el-select v-model="userForm.system" placeholder="请选择系统" @focus="getSystemList" filterable>
            <el-option :label="item.system_name" :value="item.system" v-for="item in systemList" :key="item.system_id" ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="菜单：" prop="menu_name" >
          <el-input placeholder="请填写菜单" v-model="userForm.menu_name" ></el-input>
        </el-form-item>
        <el-form-item label="查询条件：" prop="search_key" >
          <el-input placeholder="请填写查询条件" v-model="userForm.search_key"></el-input>
        </el-form-item>
        <el-form-item label="查询内容：" prop="search_content" >
          <el-input placeholder="请填写查询内容" v-model="userForm.search_content"></el-input>
        </el-form-item>
        <el-form-item label="备注：" prop="remark" >
          <el-input placeholder="请填写备注" v-model="userForm.remark" maxlength="100" show-word-limit></el-input>
        </el-form-item>
      </div>

      <el-form-item class="btnForm">
        <span class="button btn-add" @click="submitForm()"> 确定</span>
        <span class="button" @click="cancle()">取消</span>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import {add,editPost, editGet,systemListApi, getUsername } from '@/api/manageConfig'

export default {
  data(){
    return {
      isAdd:true,
      id:"",
      userForm:{
        id: void 0,
        employee_id:'',
        username:"",
        system:"",
        menu_name:"",
        search_key:"",
        search_content:"",
        remark: '',
      },
      rules:{
        employee_id:[      
          {required: true, message: '请输入员工ID！', trigger: 'blur'},
          {pattern:/^[1-9]\d*$/, message: '只能填写大于 0 的整数！', trigger: 'blur' },
          {max:10, message: '员工ID最大长度为 10 字符', trigger: 'blur' },
        ],
        system:[
          {required: true, message: '请选择系统！', trigger: 'blur'},
        ],
        menu_name:[
          {required: true, message: '请填写菜单！', trigger: 'blur'},
          {max:20, message: '菜单的最大长度为 20 字符', trigger: 'blur' },
        ],
        search_key: [
          {required: true, message: '请填写查询条件！', trigger: 'blur'},
          {max:50, message: '查询条件的最大长度为 50 字符', trigger: 'blur' },
        ],
        search_content: [
          {required: true, message: '请填写查询内容！', trigger: 'blur'},
          {max:20, message: '查询内容的最大长度为 20 字符', trigger: 'blur' },
        ],
      },
      changeFlag: false,
      systemList:[]
    }
  },
  props:['showUserOpts'],
  watch:{
    showUserOpts:function(n,o){
      if(n){
        if(this.id){
          this.changeFlag = true
          this.getUser();
        }else{
          this.$refs.optsForm.clearValidate();
        }
      }
    },
  },
  created(){
    
  },
  methods:{
    getSystemList(){
      systemListApi().then(res=>{
        this.systemList = res
      })
    },
    getUser(){
      let params = {
        id: this.id
      }
      editGet(params).then(res=>{
        this.userForm = res
      })
    },
    ChangeId(){
      let params = {
        employee_id: this.userForm.employee_id
      }
      getUsername(params).then(res => {
        this.userForm.username = res.username
      })
    },
    cancle:function(){
      this.$refs.optsForm.resetFields()
      this.$emit('isShowUserOpts',false)
    },
    submitForm(){
      if(this.isAdd){
        this.addUser()
      }else{
        this.editUser()
      }
    },
    addUser(){
      add(this.userForm).then(res=>{
          this.$emit('searchList')
          this.$message({message:'新增成功！',type:'success'})
          this.cancle()
      })
    },
    editUser(){
      editPost(this.userForm).then(res=>{
        if(res.length == 0){
          this.$emit('searchList')
          this.$message({message:'编辑成功！',type:'success'})
          this.cancle()
        }
      })
    },

  }

}
</script>

<style lang='scss' scoped>
@import '@/assets/scss/maskForm.scss';
.userOptions {
  >.el-form{
    height: 66%;
    padding:0;
    min-width: 600px;
    min-height: 480px;
    overflow: hidden;
    >p.title{
      height: 6.7vh;
      padding-top: 2vh;
      z-index: 5;
      background-color: #ffffff;
      padding-left: 30px;
      margin-bottom: 0;
    }
    .scrollDiv{
      padding-left: 40px;
      height: calc(100% - 16vh);
      overflow-y: auto;
      margin-right: 9px;
      >.el-form-item{
        padding-right: 64px;
      }
    }
    .power{
      font-size: 14px;
    }
    .btnForm{
      padding-top: 2vh;
      height: 5vh;
      z-index: 5;
      background-color: #ffffff;
      margin: 0;
      margin-bottom: 0 !important;
      /deep/.el-form-item__content{
        margin-left: 0 !important;
      }
    }
    .inputRole{
      /deep/.el-input__inner{
        width: 360px;
      }
    }
    .el-select{
      width: 100%;
    }
    .attachfile {
      white-space: nowrap;
      .el-input{
        width: 72%;
      }
      .upload{
        position: relative;
        height:35px;line-height:35px;
        width: calc(28% - 16px) ;
        input{
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          opacity: 0;
        }
      }
    }

    .secTitle{
      font-size: 14px;
      // font-family: 'SC-Bold';
      font-family:  Noto Sans SC;
      font-weight: 700;
      margin-bottom: 16px;
    }
    .system{
      display: flex;
      align-items: center;
      .el-form-item{
        /deep/.el-form-item__content{
          width: 136px;
        }
        &.role{
          /deep/.el-form-item__content{
            // width: calc(50% - 100px);
            margin-left: 90px !important;
          }
          /deep/.el-form-item__label{
            width: 90px !important;
          }
        }
       
        
      }
     
      .addRole{
        width: 64px;
        white-space: nowrap;
        line-height: 37px;
      }
      .icon{
        width: 16px;
        height: 16px;
        position: relative;
        top: -10px;
        margin-left:10px;
      }
    }
  }

}

</style>